<template>
  <div class="articlecategories">
    <section>
      <b-field group-multiline grouped>
        <div class="control">
          <router-link class="" to="/articlecategories/new">
            <b-button type="is-primary"><i class="fa fa-plus"></i>&nbsp;Neue Artikelgruppe</b-button> &nbsp;
          </router-link>
        </div>

        <div class="control">

          <b-button type="is-primary" @click="fetchData"><i class="fa fa-recycle"></i>&nbsp;Aktualisieren</b-button>

        </div>
        <!--<b-select v-model="defaultSortDirection">
            <option value="asc">Default sort direction: ASC</option>
            <option value="desc">Default sort direction: DESC</option>
        </b-select>-->
        <b-select v-model="perPage" :disabled="!isPaginated">
          <option value="10">10 je Seite</option>
          <option value="20">20 je Seite</option>
          <option value="50">50 je Seite</option>
        </b-select>
        <!--<div class="control">
            <button class="button" @click="currentPage = 2" :disabled="!isPaginated">Set page to 2</button>
        </div>-->
<!--        <div class="control is-flex">-->
<!--          <b-switch v-model="isPaginated">Paginated</b-switch>-->
<!--        </div>-->
<!--        <div class="control is-flex">-->
<!--          <b-switch v-model="isPaginationSimple" :disabled="!isPaginated">Simple pagination</b-switch>-->
<!--        </div>-->
<!--        <b-select v-model="paginationPosition" :disabled="!isPaginated">-->
<!--          <option value="bottom">bottom pagination</option>-->
<!--          <option value="top">top pagination</option>-->
<!--          <option value="both">both</option>-->
<!--        </b-select>-->
<!--        <b-select v-model="sortIcon">-->
<!--          <option value="arrow-up">Arrow sort icon</option>-->
<!--          <option value="menu-up">Caret sort icon</option>-->
<!--          <option value="chevron-up">Chevron sort icon</option>-->
<!--        </b-select>-->
<!--        <b-select v-model="sortIconSize">-->
<!--          <option value="is-small">Small sort icon</option>-->
<!--          <option value="">Regular sort icon</option>-->
<!--          <option value="is-medium">Medium sort icon</option>-->
<!--          <option value="is-large">Large sort icon</option>-->
<!--        </b-select>-->

      </b-field>

      <b-table
          :current-page.sync="currentPage"
          :data="data"
          :default-sort-direction="defaultSortDirection"
          :paginated="isPaginated"
          :pagination-position="paginationPosition"
          :pagination-simple="isPaginationSimple"
          :per-page="perPage"
          :sort-icon="sortIcon"
          :sort-icon-size="sortIconSize"
          aria-current-label="Current page"
          aria-next-label="Next page"
          aria-page-label="Page"
          aria-previous-label="Previous page"
          default-sort="name">

        <template>
          <b-table-column field="id" label="ID" numeric sortable width="40" v-slot="props">
            {{ props.row.id }}
          </b-table-column>

          <b-table-column field="name" label="Name / Bezeichnung" searchable sortable v-slot="props">
            {{ props.row.name }}
          </b-table-column>

          <b-table-column field="name" label="Beschreibung" searchable sortable v-slot="props">
            {{ props.row.description }}
          </b-table-column>

          <b-table-column label="Aktionen" v-slot="props">
<!--            <b-button type="is-light">Stornieren</b-button>-->
<!--            <router-link class="" to="/invoice">-->
              <b-button type="is-primary" @click="openItem(props.row.id)"><i class="fa fa-eye"></i>&nbsp;Bearbeiten</b-button>
<!--            </router-link>-->


          </b-table-column>
        </template>
      </b-table>
    </section>
  </div>
</template>

<script>

import ArticleCategory from "@/views/ArticleCategory";
import apiservice from "@/services/apiservice";

export default {
  name: 'ArticleCategoryOverview',
  props: {
    msg: String
  },
  components: {
    // ArticleCategory
  },
  data() {
    return {
      data: [],
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: 'bottom',
      defaultSortDirection: 'asc',
      sortIcon: 'arrow-up',
      sortIconSize: 'is-small',
      currentPage: 1,
      perPage: 10
    }
  },
  methods: {
    fetchData: function() {
      apiservice()
          .get("articles/categories")
          .then(response => (this.data = response.data.data));
    },
    createNew: function(){
      this.$buefy.modal.open({
        parent: this,
        component: ArticleCategory,
        hasModalCard: true,
        trapFocus: true
      })
    },
    // eslint-disable-next-line no-unused-vars
    openItem: function(id){
      this.$router.push({ path: `/articlecategories/${id}` })
    }
  },
  beforeMount(){
    this.fetchData()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
